module.exports = __webpack_public_path__ + "static/media/checkIcon.2b50cb8d.svg";